module.exports = __webpack_public_path__ + "static/A_Z_order_Bantu_market-198122f0978268c988d20b58c0baae71.png";